import { OrderActivityLog } from 'types/OrderActivityLog'

export function getOrderActivityLogPrimaryText(log: OrderActivityLog) {
  const { type } = log
  const mapping = {
    ORDER_ACCEPTED: `Order Accepted`,
    ORDER_PROCESSING: `Order Processing`,
    ORDER_CREATED: `Order Created`,
    ORDER_CANCELLED: `Order Cancellation`,
    ORDER_CONFIRMED: `Order Confirmation`,
    ORDER_MODIFICATION_ACCEPTED: `Order has been modified`,
    ORDER_MODIFICATION_CREATED: `Order modifications submitted`,
    ORDER_MODIFICATION_PROCESSING: `Order modifications still processing`,
    ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT: `Order has been modified`,
    ORDER_MODIFICATION_REJECTED: `Order has not been modified`,
    ORDER_PLUS_LOAD_CREATED: `A plus load has been submitted`,
    ORDER_PLUS_LOAD_APPLIED: `Plus load quantity is now included`,
    ORDER_PLUS_LOAD_REJECTED: `Plus load quantity has been removed`,
  }
  return mapping[type]
}
